export const MIN_HOURLY_RATE_MINOR = 10000; // ₹100/hour
export const MAX_HOURLY_RATE_MINOR = 5000000; // ₹50,000/hour
/** What we keep on a commission. Snapshotted per engagement, so changing it
 *  never rewrites what a live or past commission owed. */
export const COMMISSION_RATE_PCT = 20;
/**
 * The lifecycle, as an explicit table rather than scattered status checks.
 *
 * Two rules are load-bearing and easy to lose if this is ever rewritten as
 * conditionals:
 *
 * ACCEPTANCE COMES BEFORE PAYMENT. A designer must be able to turn down a brief
 * they cannot take — wrong subject, no capacity, a client they would rather
 * not work with — without a refund having to happen. So DECLINED is reachable
 * only from ENQUIRY, and money only moves once somebody has agreed to the work.
 *
 * NOTHING REACHES APPROVED WITHOUT PASSING THROUGH PAID. Approval is what
 * releases the designer's earning, so a path around payment is a path to being
 * owed money for an order that never happened.
 */
export const COMMISSION_TRANSITIONS = {
    ENQUIRY: [
        { to: 'ACCEPTED', allowedActors: ['designer', 'admin'], label: 'Take this on' },
        { to: 'DECLINED', allowedActors: ['designer', 'admin'], label: 'Decline' },
        { to: 'CANCELLED', allowedActors: ['customer', 'admin'], label: 'Withdraw' },
    ],
    ACCEPTED: [
        // Only the payment webhook moves this. An admin marking a commission paid
        // by hand would owe the designer money nobody collected.
        { to: 'PAID', allowedActors: ['system'], label: 'Payment captured' },
        { to: 'CANCELLED', allowedActors: ['customer', 'designer', 'admin'], label: 'Cancel' },
    ],
    PAID: [
        { to: 'DELIVERED', allowedActors: ['designer', 'admin'], label: 'Deliver files' },
        { to: 'CANCELLED', allowedActors: ['admin'], label: 'Cancel and refund' },
    ],
    DELIVERED: [
        { to: 'APPROVED', allowedActors: ['customer', 'admin'], label: 'Approve' },
        { to: 'REVISION', allowedActors: ['customer', 'admin'], label: 'Ask for a change' },
        { to: 'CANCELLED', allowedActors: ['admin'], label: 'Cancel and refund' },
    ],
    REVISION: [
        { to: 'DELIVERED', allowedActors: ['designer', 'admin'], label: 'Deliver revision' },
        { to: 'CANCELLED', allowedActors: ['admin'], label: 'Cancel and refund' },
    ],
    APPROVED: [],
    DECLINED: [],
    CANCELLED: [],
};
export function canTransitionCommission(from, to, actor) {
    return COMMISSION_TRANSITIONS[from].some((t) => t.to === to && t.allowedActors.includes(actor));
}
export function commissionTransitionsFor(from, actor) {
    return COMMISSION_TRANSITIONS[from].filter((t) => t.allowedActors.includes(actor));
}
/** Terminal states carry no transitions, so this needs no separate list to
 *  drift out of step with the table above. */
export function isCommissionFinal(status) {
    return COMMISSION_TRANSITIONS[status].length === 0;
}
/** Whether another revision is still included in what the customer bought. */
export function hasRevisionsLeft(commission) {
    return commission.revisionsUsed < commission.package.revisions;
}
export function packagePriceMinor(pkg, hourlyRateMinor) {
    return Math.round(pkg.hours * hourlyRateMinor);
}
//# sourceMappingURL=commission.js.map